import {
  Button,
} from "@mui/material";
import React from "react";
import { usePslHistory } from "../services/hooks";
import { Footer } from "antd/es/layout/layout";
import { useNavigate, useParams } from "react-router-dom";
import { PromoHistoryTable } from "./PromoHistoryTable.component";

export const PromoHistoryComponent = () => {
  const navigate = useNavigate();
  const { promoId } = useParams();
  const { materialId } = useParams();

  const { data, isLoading } = usePslHistory(promoId, materialId);

  return <>
    <div style={{ flexDirection: 'row' }}>
      <h2>Suppler Catalogs History</h2>
    </div>
    <div>
      <PromoHistoryTable
        showBorder={false}
        loading={isLoading}
        data={data || []}
        totalCount={data?.length || 0}
      />
    </div>
    <Footer>
      <Button variant="contained" color="primary"
        onClick={() => navigate(-1)}>Back</Button>
    </Footer>
  </>
};

export default PromoHistoryComponent